module.exports = __webpack_public_path__ + "img/Näckrosor-Harstena.f79f4b70.jpg";